export const REQUEST_PROSPECT_REASSIGNMENT = `
  mutation requestProspectReassignment($input: RequestProspectReassignmentInput!, $tenant_id: Int!) {
    requestProspectReassignment(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProspectReassignment {
        id
        prospect_id
        requester_chair_id
        owner_chair_id
        staff_approver_id
        reason
        status
        has_conflict
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const APPROVE_PROSPECT_REASSIGNMENT_AS_CHAIR = `
  mutation approveProspectReassignmentAsChair($input: ApproveProspectReassignmentInput!, $tenant_id: Int!) {
    approveProspectReassignmentAsChair(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProspectReassignment {
        id
        status
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const APPROVE_PROSPECT_REASSIGNMENT_AS_STAFF = `
  mutation approveProspectReassignmentAsStaff($input: ApproveProspectReassignmentInput!, $tenant_id: Int!) {
    approveProspectReassignmentAsStaff(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProspectReassignment {
        id
        status
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REJECT_PROSPECT_REASSIGNMENT = `
  mutation rejectProspectReassignment($input: RejectProspectReassignmentInput!, $tenant_id: Int!) {
    rejectProspectReassignment(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on ProspectReassignment {
        id
        status
        rejection_reason
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
